import React from 'react';
import PropTypes from 'prop-types';
import styles from './ReplayDelayNote.module.css';
import { ReactComponent as InfoIcon } from 'assets/images/icon_info_circle.svg';

// Shown on the admin cards whose changes the season replay finishes in the background: result edits,
// event edits, a meet's points settings and the club's points settings. The edited result's own star
// and season best update at once; other results' stars, season-best records affected indirectly, the
// points report and Pending Records (club records) follow after the API's debounce
// (SeasonReplay:DebounceMinutes, 60 in production).
// The website cannot read that setting, so the delay wording lives here and nowhere else.
export const REPLAY_DELAY_WORDING = 'up to an hour';

// organisationWord: "club", or "school" for a school, which reads "school records" (Doug, 2026-10-26,
// school words pass 1). Each screen passes the word of the club it is working for (organisationWordOf).
const ReplayDelayNote = ({ lead, className, organisationWord = 'club' }) => (
  <div className={`${styles.note} ${className || ''}`.trim()} role="note">
    <InfoIcon className={styles.icon} aria-hidden="true" />
    <span className={styles.text}>
      {lead ? `${lead} ` : ''}
      Changes saved here are applied to season points, season bests and {organisationWord} records in the
      background.
      Allow {REPLAY_DELAY_WORDING} for the Athlete Points report, season best values and Pending Records
      to update, or press <strong>Recalculate Points</strong> on the Athlete Points report to apply them
      now.
    </span>
  </div>
);

ReplayDelayNote.propTypes = {
  /** Optional short sentence placed before the standard wording, for context specific to the card. */
  lead: PropTypes.string,
  className: PropTypes.string,
  /** "club" or "school": the organisation whose records the note names. */
  organisationWord: PropTypes.string,
};

export default ReplayDelayNote;
